import React from 'react';
import { IProductData } from 'interfaces/IProductData';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { BaseComponent } from 'components/BaseComponent';
import { enProductType } from 'enums/enProductType';
import { Translate } from 'components/Translate';
import TooltipInternational from './Tooltip';

interface IPriceProps {
  cart: IProductData;
}

export default class International extends BaseComponent<null, IPriceProps> {
  render() {
    const { price, taxedPrice, tax, config } = this.props.cart;
    const product = this.props.cart.products[0];

    if (product.totalPrice === 0 && product.type === enProductType.PHYSICAL) {
      return (
        <div className="chk-full">
          <span className="chk-full-price theme-label">
            <Translate term="Grátis" />
          </span>
          <div className="chk-parts without-installments">
            <div className="chk-small-price">
              <Translate term="Frete de" /> <CurrencyFormat value={taxedPrice} />
            </div>
            <div className="chk-small-price">
              Cart value: <CurrencyFormat value={price} />
            </div>
            <div className="chk-small-price">
              Fee/charge: <CurrencyFormat value={tax} />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="chk-full">
        <span className="chk-full-price theme-label" style={{ position: 'relative' }}>
          <CurrencyFormat value={taxedPrice} />
          <TooltipInternational templateId={Number(config?.template?.id)} />
        </span>
        <div className="chk-parts without-installments">
          <div className="chk-small-price">
            Cart value: <CurrencyFormat value={price} />
          </div>
          <div className="chk-small-price">
            Fee/charge: <CurrencyFormat value={tax} />
          </div>
        </div>
      </div>
    );
  }
}
